import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";
import type { ImportSummary } from "components/ReportImportModal";

const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const useDownloadAttendanceTemplate = () =>
  useMutation<void, AxiosError>(
    async () => {
      const res = await customAxios.get("/reports/attendance/import/template", {
        responseType: "blob",
      });
      downloadBlob(res.data as Blob, "Attendance_Import_Template.xlsx");
    },
    {
      onError: () =>
        showNotification({
          title: "Download failed",
          message: "Could not download the template.",
          color: "red",
        }),
    }
  );

const importAttendance = async (file: File): Promise<ImportSummary> => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await customAxios.post<{ success: boolean; data: ImportSummary }>(
    "/reports/attendance/import",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data.data;
};

export const useImportAttendanceReport = () =>
  useMutation<ImportSummary, AxiosError, File>(importAttendance, {
    onError: (error) =>
      showNotification({
        title: "Import failed",
        message:
          (error?.response?.data as any)?.message ||
          "Could not import the file.",
        color: "red",
      }),
  });
